import { render, staticRenderFns } from "./BodyStyle.vue?vue&type=template&id=f861cdc8&"
import script from "./BodyStyle.vue?vue&type=script&lang=js&"
export * from "./BodyStyle.vue?vue&type=script&lang=js&"
import style0 from "./BodyStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports